<template>
  <b-modal
    v-model="isShow"
    @hidden="
      () => {
        $emit('update:isShow', false);
        formData = {};
      }
    "
    dialog-class="dialog-class"
    centered
  >
    <template #modal-header="{ close }">
      <h4 class="mb-0 text-primary">
        {{ $t("ar_client_quick_create_from_payment") }}
      </h4>
      <!--  <h4 class="mb-0 text-primary" v-else>
          {{ $t("ar_client_update_debit_account") }}
        </h4> -->
      <ez-icon
        icon="ezAr-icon-x"
        size="24"
        class="cursor-pointer"
        color="#114A9F"
        @click="close()"
      />
    </template>
    <FormItems
      @input-change="onInputChange"
      ref="formRef"
      :formData.sync="formData"
      :items="formItems"
    />
    <template #modal-footer="">
      <LoadingModalButton
        ref="buttonRef"
        :disabled="isLoading"
        @click="createAutomation"
        variant="primary"
      >
        {{ $t("ar_common_save") }}
      </LoadingModalButton>
    </template>
  </b-modal>
</template>
<style lang="scss">
.dialog-class {
  max-width: 500px;
}
</style>
<script>
import { computed, ref, defineComponent, getCurrentInstance, onMounted } from "@vue/composition-api";
import LoadingModalButton from "../../ultils/Button/LoadingModalButton.vue";
import FormItems from "../../ultils/Form/FormItems.vue";
import { PaymentDetailTypeStatus } from "../../ultils/status";
import { useFetch } from "../../ultils/Hooks/useFetch.ts";

import { arClient } from "@/api/ar-client";
import _ from "lodash";
import { watch } from "@vue/runtime-dom";
export default defineComponent({
  name: "ModalQuickAction",
  components: {
    LoadingModalButton,
    FormItems,
  },
  props: {
    isShow: Boolean,
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy;
    const formData = ref({ PaymentDate: vm.getUTC("start", "day"),PaymentDetailType:"PAYMENT",TotalAmount:0});
    const buttonRef = ref();
    const formRef = ref();

    const formItems = computed(() => [
    {
        type: "select",
        dataSource: PaymentDetailTypeStatus.map((stt) => ({ Label: vm.$t(stt.title), Id: stt.value })),
        noClearable: true,
 
        name: "PaymentDetailType",
        labelOption: "Label",
        label: "ar_client_payment_type",
        wrapperClass: "col-6",
      },
      {
        type: "select",
        name: "TravelAgentId",
        dataSourceParams: {
          Status: 1,
          IsCheckPermission:false,
        },
        required: true,
        dataSource: arClient.api_AR_RCL01,

        customOptions: (options) =>
          options.map((option) => ({
            ...option,
            CodeName: `${option.TravelAgentCode} - ${option.NameVi}`,
          })),
        labelOption: "CodeName",
        label: "ar_client_company",
        placeholder: "ar_client_company",
      },

      {
        type: "select",
        required: true,
        dataSource: arClient.api_AR_RAA01,

        dataSourceParams: {
          InActive: 1,
          ArTravelAgentId: formData.value.TravelAgentId,
          IsCheckPermission:false
        },
        label: "ar_client_debit_account",

        labelOption: "AccountCode",
        name: "AccountId",
      },
      {
        required: true,
        type: "cleave",
        
        cleaveType: "numeral",
        cleaveOptions:{
          isNumberPositive:formData.value.PaymentDetailType !== "MODIFY"
        },
      /*   customValidate:{
          isValid:(v)=>{
            return v > 300
          },
          message:"ar_client_number_1_to_10_billion"
        }, */
        maxValue:300,
        rules: {
          maxValue:10000000000,
          max: 12,
        },
        labelAfterFix: " (VND)",
        showVnPriceText: true,
        name: "TotalAmount",
        label: "ar_client_total_money",
      },
      {
        required: true,
        type: "string",
        name: "Payer",
        label: "ar_client_payer",
        rules: {
          max: 100,
        },
      },

      {
        type: "date",
        required: true,
        noClearable: true,
        timePicker: true,
        name: "PaymentDate",
        maxDate:vm.dayjs().endOf('day'),
        label: "ar_client_payment_date",
      },
      {
        wrapperClass: "col-12",
        type: "string",
        rules: {
          max: 255,
        },
        variant: "textarea",
        name: "Note",
        label: "ar_client_note",
      },
    ]);

    const { fetchData: mutation, isLoading } = useFetch(arClient.api_AR_IQA01, {
      showLoading: true,
      afterErrorOrTimeoutFunction: {
        func: () => buttonRef?.value?.stopLoading(),
      },
      nextFunction: (data) => {
        emit("afterSave");
      },
    });

    const createAutomation = () => {
      formRef.value.validate().then((success) => {
        if (success) {
          buttonRef?.value?.startLoading();
          mutation({ ...formData.value ,TotalAmount:+formData.value.TotalAmount});
        }
      });
    };
    const minAmount = computed(()=>{
      let min = 0
      if(formData.value.PaymentDetailType === "TOPUP"){
        min = 0
      }
      return min
    })

    const onInputChange = (name, v) => {
      console.log(name,"1722")
      if (name === "TravelAgentId") {
        formData.value.AccountId = [];
      }
      if(name === "PaymentDetailType"){
        
        formData.value.TotalAmount = 0
      }
    };
    onMounted(()=>{
      console.log(vm.dayjs(),'1788')
    })

    return {
      buttonRef,
      isLoading,
      formData,
      formItems,
      createAutomation,
      formRef,

      onInputChange,
    };
  },
  methods: {
    test() {},
  },
});
</script>
